import { render, staticRenderFns } from "./AddThanks.vue?vue&type=template&id=63e16f5e&scoped=true&"
import script from "./AddThanks.vue?vue&type=script&lang=js&"
export * from "./AddThanks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e16f5e",
  null
  
)

export default component.exports